var map = {
	"./stack_0.png": 16942,
	"./stack_1.png": 46167,
	"./stack_2.png": 88060,
	"./stack_3.png": 70949,
	"./stack_4.png": 4074,
	"./stack_5.png": 59283,
	"./stack_6.png": 13528,
	"./stack_7.png": 34657
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60937;